import { abyssColors } from '@/theme/colors';
import { Box, Typography } from '@mui/material';

export const QaqcPanelHeaderTitle = () => {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="h3"
        sx={{ fontWeight: 500, fontSize: '2.4rem', color: abyssColors.primary[600] }}
      >
        Job phase
      </Typography>
      <Typography variant="body2" color={abyssColors.primary[400]} sx={{ mt: 0.5 }}>
        Fill out all required fields and submit the report
      </Typography>
    </Box>
  );
};
